import { useSelector } from 'react-redux';
import KushkiLogo from '../../../../../../images/logos/kushkiLogo.png';
import { LATINA_COUNTRY_CODE } from '../../../../../../constants/latina-country';
import { PAYMENT_METHOD_KEYS } from '../../../../payment.constants';
import usePaymentOptions from '../../../../../../services/payment/use-payment-options';

const KushkiInfo = () => {
    const { activePaymentOption } = useSelector((state: RootState) => state.payment);
    const currency = useSelector((state: RootState) => state.main.currency);
    const { data: paymentOptionsData } = usePaymentOptions(currency.code);

    return (
        <>
            <div className='kushki-text text-center'>
                Este pago es procesado de forma segura por Kushki, un proveedor de pagos PCI de nivel 1.
            </div>
            <div className='text-center'>
                <img alt='logo of kushki' className='mr-1' src={KushkiLogo} />
            </div>
            {paymentOptionsData?.userCountry === LATINA_COUNTRY_CODE.CO && activePaymentOption?.id === PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER && (
                <div className='text-center'>
                    <img
                        alt='logo of PSE'
                        className='pse mr-1'
                        src='https://play-lh.googleusercontent.com/xSPYd7G8NduXFxEvSxGGo2sgvysuzBN-mdHXD9YGOzgTdE0g4Y5tnjB7gDm6WeWqtTw'
                    />
                </div>
            )}
        </>
    );
};

export default KushkiInfo;
